exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rank[data-v-13b61f83] {\n  width: 45px;\n  text-align: center;\n  margin-top: 0.6rem;\n}\n.entry-label[data-v-13b61f83] {\n  max-width: 90%;\n}\n.highlighted .name[data-v-13b61f83],\n.highlighted .description[data-v-13b61f83] {\n  font-weight: bold;\n}", ""]);

// exports
